// extracted by mini-css-extract-plugin
export default {"form":"EditEntity_form__73Gn4","error":"EditEntity_error__IDCJn"};